// @flow
/** @jsx h */
import { h } from 'preact';
import SlickSlider from '../../../../components/common/slickSlider';
import styles from './style.css';

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  const customeStyle = {
    display: 'block',
    position: 'absolute',
    right: '-65px',
    top: '50%',
    transform: 'translate(-50%,-50%)',
  };
  return (
    <div style={{ ...style, ...customeStyle }} onClick={onClick}>
      <span class={`material-icons cursorPointer ${styles.arrowSize}`}>
        navigate_next
      </span>
    </div>
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  const customeStyle = {
    display: 'block',
    position: 'absolute',
    left: '-30px',
    top: '50%',
    transform: 'translate(-50%,-50%)',
  };
  return (
    <div style={{ ...style, ...customeStyle }} onClick={onClick}>
      <span class={`material-icons cursorPointer ${styles.arrowSize}`}>
        navigate_before
      </span>
    </div>
  );
}

const merhchantSliderSettings = {
  dots: true,
  dotsClass: `slick-dots ${styles.customPagination}`,
  customPaging: function(i) {
    return <div className={styles.pagination} />;
  },
  autoplay: true,
  rows: 1,
  infinite: true,
  speed: 500,
  autoplaySpeed: 3000,
  slidesToShow: 4,
  slidesToScroll: 4,
  arrows: true,
  placeholders: false,
  mobileFirst: false,
  nextArrow: <SampleNextArrow />,
  prevArrow: <SamplePrevArrow />,
  responsive: [
    {
      breakpoint: 600,
      settings: {
        rows: 2,
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true,
        arrows: true,
      },
    },
  ],
};

const merchantArray = [
  {
    img: 'https://iccdn.in/img/merchant-desktop-amazon.jpg',
    name: 'Amazon',
  },
  {
    img: 'https://iccdn.in/img/merchant-desktop-flipkart.jpg',
    name: 'Flipkart',
  },
  {
    img: 'https://iccdn.in/img/merchant-desktop-tata-cliq.jpg',
    name: 'TATA Cliq',
  },
  {
    img: 'https://iccdn.in/img/merchant-vijaysales.jpg',
    name: 'Vijay Sales',
  },

  {
    img: 'https://iccdn.in/img/merchant-sangeetha-mobiles.jpg',
    name: 'Sangeetha Mobiles',
  },

  {
    img: 'https://iccdn.in/img/merchant-desktop-myntra.jpg',
    name: 'Myntra',
  },
  {
    img: 'https://iccdn.in/img/merchant-decathlon.jpg',
    name: 'Decathlon',
  },
  {
    img: 'https://iccdn.in/img/merchant_cult.fit_v2.png',
    name: 'Cult fit',
  },
  {
    img: 'https://iccdn.in/img/merchant-mmt.jpg',
    name: 'Make My Trip',
  },
  {
    img: 'https://iccdn.in/img/merchant-desktop-via.jpg',
    name: 'Via',
  },

  {
    img: 'https://iccdn.in/img/merchant-sastiticket.jpg',
    name: 'Sasti Ticket',
  },
  {
    img: 'https://iccdn.in/img/merchant-happyeasygo-sale.jpg',
    name: 'Happy Easy Go',
  },
  {
    img: 'https://iccdn.in/img/merchant-pepperfry-new.jpg',
    name: 'Pepperfry',
  },
  {
    img: 'https://iccdn.in/img/merchant-royaloak.jpg',
    name: 'Royal Oak',
  },

  {
    img: 'https://iccdn.in/img/merchant-ikea.jpg',
    name: 'Ikea',
  },
  {
    img: 'https://iccdn.in/img/merchant-urbanladder.jpg',
    name: 'Urban Ladder',
  },
  {
    img: '  https://iccdn.in/img/merchant-desktop-gonoise.jpg',
    name: 'Gonoise',
  },
  {
    img: 'https://iccdn.in/img/merchant-asics.jpg',
    name: 'Asics',
  },
  {
    img: 'https://iccdn.in/img/merchant-titan.jpg',
    name: 'Titan',
  },
  {
    img: 'https://iccdn.in/img/merchant-fossil.jpg',
    name: 'Fossil',
  },
];
const MerchantCarousel = () => {
  return (
    <div
      className={`${styles.aboutContents}  ${styles.merchantSliderContainer} ${
        styles.achievementsWrapper
      } font14`}
    >
      <SlickSlider setting={merhchantSliderSettings}>
        {merchantArray.map((itm, index) => {
          return (
            <div className={`cursorPointer`}>
              <div className={styles.imageContainer}>
                <div
                  style={{
                    backgroundImage: `url(${itm.img})`,
                  }}
                  className={`${styles.image}`}
                />
              </div>
            </div>
          );
        })}
      </SlickSlider>
    </div>
  );
};

export default MerchantCarousel;



// WEBPACK FOOTER //
// ./routes/campaign-activation/componentsVD/merchantsCarousel/index.js